import { AxiosResponse } from "axios";
import { saveBlobResponse } from "../../../utils/downloadBlob";

/**
 * Show a PDF response in a new tab (to read or print); if the browser blocks the pop-up, save
 * it instead. The object URL is revoked a minute later — long enough for the tab to load it.
 */
export const openPdfResponse = (response: AxiosResponse, fallbackName: string): void => {
  const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob.type === "application/pdf" ? blob : new Blob([blob], { type: "application/pdf" }));
  // no "noopener": with it window.open always returns null and every PDF would be saved instead
  const tab = window.open(url, "_blank");
  if (!tab) {
    saveBlobResponse(response, fallbackName);
  }
  window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
};
